import React from "react";

import {
  AnchorCheckboxContainer,
  AnchorInput,
  AnchorLabel,
  AnchorTooltip,
} from "./styles";
import { useSearchResults } from "../../../data/useSearchResults";

const AnchorCheckbox = ({ isFocused }) => {
  const { anchors, setUseAnchors, useAnchors } = useSearchResults();

  if (!anchors?.length) {
    return <></>;
  }

  return (
    <AnchorCheckboxContainer
      id="bn-search__anchor-container"
      isFocused={isFocused}
    >
      <AnchorTooltip id="bn-search__anchor-tooltip">
        {anchors[0]?.name}
      </AnchorTooltip>

      <AnchorInput
        type="checkbox"
        id="bn-search__anchor-input"
        name="bn-search__anchor-input"
        checked={useAnchors}
        onChange={() => setUseAnchors(!useAnchors)}
      />

      <AnchorLabel for="bn-search__anchor-input" id="bn-search__anchor-label">
        Somente em {anchors[0]?.name}
      </AnchorLabel>
    </AnchorCheckboxContainer>
  );
};

export default AnchorCheckbox;
